import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../shared/services/notification/notification.service';
import { NotificationType } from '../../shared/models/notification-type';
import { ManageLocationsService } from '../services/manage-locations.service';
import { Location } from '../../shared/models/location/location.model';
import { ZipCodeService } from '../../shared/services/zip-code/zip-code.service';
import { ValidationService } from '../../shared/services/validation/validation.service';
import * as _ from 'lodash';
import { ErrorHandlerService } from '../../shared/services/error-handler/error-handler.service';

@Component({
  selector: 'upsc-add-edit-location',
  templateUrl: './add-edit-location.component.html',
  styleUrls: ['./add-edit-location.component.scss']
})
export class AddEditLocationComponent implements OnInit {

  //  public editMode: boolean;
  public countriesList: any[];
  public isZipMandatory = true;
  public formGroup: UntypedFormGroup;
  public isFRITUser: false;
  /*@Input() locationId: string;
  @ViewChild('locationForm') locationForm: any;*/

  constructor(private locationService: ManageLocationsService,
              public shippingLocation: Location,
              public dialogRef: MatDialogRef<AddEditLocationComponent>,
              private zipcodeservice: ZipCodeService,
              private notificationService: NotificationService,
              // private userService: UserService,
              private errorHandlerService: ErrorHandlerService,
              private formBuilder: UntypedFormBuilder,
              private validationService: ValidationService,
              private translateService: TranslateService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.GetCountries();
  }

  GetCountries() {
    this.locationService.getCountries().subscribe(
      (countries) => {
        if (countries) {
          this.countriesList = _.sortBy(countries, ['CountryName']);
        }
      },
      (error) => {
        this.notificationService.notify(
          this.errorHandlerService.getHttpErrorMessage(error),
          this.translateService.instant('CountriesLoadingError_msg'),
          NotificationType.ERROR);
      });
  }

  saveLocation() {
    if (this.formGroup.valid) {
      this.mapFormValueToShipLocationObject();
      this.populateProvinceRegion();
      this.locationService.saveLocation(this.shippingLocation).subscribe(response => {          
            this.notificationService.notify('', this.translateService.instant('LocationAdded_msg'), NotificationType.SUCCESS);
            this.dialogRef.close({ result: 'success' });          
        },
        (error) => {
          this.notificationService.notify(
            this.errorHandlerService.getHttpErrorMessage(error),
            this.translateService.instant('ErrorSavingLocation_msg'),
            NotificationType.ERROR);
        });
    }
  }

  populateProvinceRegion() {
    if (this.formGroup.controls.country.value.toLowerCase() !== 'us')
      this.shippingLocation.ProvinceRegion = this.formGroup.controls.state.value;
  }

  onCountryChange(val) {
    if (!this.countriesList || !this.countriesList.length)
      return;

    let countryObject = this.countriesList.filter(x => x.CountryCode == val);
    if (countryObject && countryObject.length > 0) {
      this.isZipMandatory = countryObject[0].IsPostalCodeAware;
      const zipControl = this.formGroup.controls.zip;
      if (this.isZipMandatory)
        this.validationService.setFormControlValidators(zipControl,
          Validators.compose([Validators.required]));
      else this.validationService.clearFormControlValidators([zipControl]);
    }
  }

  getAddressbyZipCode(event) {
    if (!['US', 'CA', 'PR', 'VI', 'GU'].includes(this.formGroup.controls.country.value)) {
      return;
    }

    if (event && event.value && event.value.length > 4) {
      this.zipcodeservice.getAddressByZipCode(event.value).subscribe(
        (address) => {
          if (address) {
            this.formGroup.controls.city.setValue(address.City.trim());
            this.formGroup.controls.state.setValue(address.State.trim());
          }
        },
        (error) => {
          this.notificationService.notify(
            this.errorHandlerService.getHttpErrorMessage(error),
            this.translateService.instant('ErrorLoadingAddress_msg'),
            NotificationType.ERROR);
        });
    }
  }

  /*validateLocation(): boolean {
      for (let control in this.locationForm.controls) {
          if (!this.locationForm.controls[control].valid) {
              this.notificationService.notify('Required: Please Enter Valid ' + control, 'Validation Failed', NotificationType.ERROR);
              return false;
          }
      }
      return true;
  }*/

  ngOnInit() {
    this.shippingLocation = new Location();
    this.isFRITUser = this.data;    
    this.initForm();
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      nickName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName: [''],
      email: ['', this.validationService.emailFormatValidator()],
      telephoneNo: ['', Validators.compose([Validators.required,  Validators.pattern('^[0-9]*$'), Validators.minLength(10)])],
      faxNo: [''],
      streetAddress: ['', Validators.required],
      apartmentSuite: [''],
      additionalAddressInfo: ['',Validators.compose([Validators.maxLength(35)])],
      country: ['US', Validators.required],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required]
    })
  }

  mapFormValueToShipLocationObject() {
    this.shippingLocation.NickName = this.formGroup.controls.nickName.value;
    this.shippingLocation.FirstName = this.formGroup.controls.firstName.value;
    this.shippingLocation.LastName = this.formGroup.controls.lastName.value;
    this.shippingLocation.CompanyName = this.formGroup.controls.companyName.value;
    this.shippingLocation.Email = this.formGroup.controls.email.value;
    this.shippingLocation.TelephoneNo = this.formGroup.controls.telephoneNo.value;
    this.shippingLocation.FaxNo = this.formGroup.controls.faxNo.value;
    this.shippingLocation.StreetAddress = this.formGroup.controls.streetAddress.value;
    this.shippingLocation.ApartmentSuite = this.formGroup.controls.apartmentSuite.value;
    this.shippingLocation.AdditionalAddressInformation = this.formGroup.controls.additionalAddressInfo.value;
    this.shippingLocation.Country = this.formGroup.controls.country.value;
    this.shippingLocation.Zip = this.formGroup.controls.zip.value;
    this.shippingLocation.City = this.formGroup.controls.city.value;
    this.shippingLocation.State = this.formGroup.controls.state.value;
  }

}
